import dayjs from 'dayjs';

export const addTravelTemplate = (product) => {
  if (!product) return;
  const travelTemplate = {
    passengerContact: {
      phone: {
        isValid: false,
        number: '',
      },
    },
    passengers: [],
  };
  for (let index = 1; index <= Number.parseInt(product.quantity, 10); index++) {
    travelTemplate.passengers.push({
      dob: {
        date: '',
        day: '',
        month: '',
        year: '',
      },
      firstName: '',
      isValid: false,
      lastName: '',
      number: index,
      title: '',
    });
  }
  product.travel = travelTemplate;
};

export const addContactNumber = (product, isValid, contactNo) => {
  if (!product) return;
  product.travel.passengerContact.phone.number = contactNo;
  product.travel.passengerContact.phone.isValid = isValid;
};

export const addPassenger = (
  product,
  number,
  isValid,
  { days, firstName, lastName, months, title, years },
) => {
  if (!product) return;
  if (!product.travel) {
    addTravelTemplate(product);
  }
  const dateISO = `${years}-${dayjs()
    .set('month', months)
    .format('MM')}-${dayjs()
    .set('date', Number.parseInt(days, 10))
    .format('DD')}T00:00:00.000Z`;

  const temporaryMonth = dayjs().set('month', months).format('MMM');
  const passenger = {
    dob: {
      date: dateISO,
      day: Number.parseInt(days, 10),
      month: temporaryMonth,
      year: years,
    },
    firstName,
    isValid,
    lastName,
    number,
    title,
  };
  if (product.travel.passengers[number - 1]) {
    product.travel.passengers[number - 1] = passenger;
  }
};

export const isTravelValid = (product) => {
  if (!product) return false;
  const isContactPhoneValid = product.travel.passengerContact.phone.isValid;
  let isAllPassengersValid = true;
  product.travel.passengers.forEach((passenger) => {
    if (!passenger.isValid) {
      isAllPassengersValid = false;
    }
  });

  return isContactPhoneValid && isAllPassengersValid;
};
